var template = '<div>'+require('!raw-loader!./index.svg')+"</div>"

module.exports = {
  template: template
}


// WEBPACK FOOTER //
// ./lib/logo/index.js